export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Concepto movimiento',
	plural_model_name_spanish: 'Concepto movimiento',
	create_model_name_spanish: 'Nuevo Concepto movimiento',
	text_delete: 'el',
}